<template>
  <div class="container">
    <head-nav-bar title="确认支付" :fixed="true" />
    <div class="mt-header-nav">
      <div class="">
        <cell-box style="padding: 0.3rem 0;">
          <cell-item label="订单编号：" :value="info.bookingNo" />
          <cell-item label="医院名称：" :value="info.hospitalName" />
          <cell-item label="挂号科室：" :value="info.departmentName" />
          <cell-item label="挂号医生：" :value="info.doctorName" />
          <cell-item label="就诊时间：" :value="info.bookingDate">
            <span slot="value">
              {{ info.bookingDate }} &nbsp; {{ info.startBookingTime }} -
              {{ info.endBookingTime }}
            </span>
          </cell-item>
          <cell-item label="患者姓名：" :value="info.cardholderName" />
          <cell-item label="就诊卡号：" :value="info.cardNo" />
          <cell-item label="付款金额：">
            <span slot="value">
              <span style="color:red;">{{ info.amount }}</span
              >元
            </span>
          </cell-item>
        </cell-box>

        <div class="box" style="margin-top:1rem">
          <van-button
            tton
            type="info"
            :loading="loading"
            block
            @click="onSubmit"
            >确认支付</van-button
          >
        </div>
      </div>
    </div>
    <form ref="form" method="post" name="auto_submit_form" :action="payAction">
      <input
        v-for="item in payParams"
        :key="item.Key"
        type="hidden"
        :name="item.key"
        :value="item.value || ' '"
      />
      <input
        type="submit"
        value="立刻提交"
        style="display:none"
        name="name"
        id="name"
      />
    </form>
    <action-sheet v-model="show" :actions="payMethod" @select="onSelect" />
  </div>
</template>

<script>
import { Field, Button, ActionSheet } from "vant";
import { CellBox, CellItem } from "@/components/cell";
import wx from "weixin-jsapi";
import weChatPayBeforeMixin from "@/mixins/weChatPayBeforeMixin";
// import Input from '../../../../../pc-fe/src/components/dataForm/formElement/Input.vue';
export default {
  name: "Confirm",
  mixins: [weChatPayBeforeMixin],
  components: {
    CellBox,
    CellItem,
    ActionSheet,
    [Field.name]: Field,
    [Button.name]: Button
  },

  data() {
    return {
      show: false,
      payMethod: [],
      loading: false,
      Id: "",
      info: {},
      payParams: [],
      payAction: ""
    };
  },
  created() {
    this.Id = this.$route.query.Id;
    this.onPayPageInit();
  },
  methods: {
    onPayPageInit() {
      this.onPayPageInitBefore().then(() => {
        if (this.Id) {
          this.getInfo();
        }
        this.$post("Common_SelectData", { Code: "MobilePayMethodDic" }).then(
          res => {
            res.data.MobilePayMethodDic.map(item => {
              this.payMethod.push({
                name: item.text,
                ...item
              });
            });
          }
        );
      });
    },
    getInfo() {
      this.$post("Booking_Detaile", {
        Id: this.Id
      }).then(res => {
        this.info = res.data;
      });
    },
    onSubmit() {
      if (this.payMethod.length == 1) {
        this.onSelect(this.payMethod[0]);
      } else {
        this.show = true;
        return;
        //这里做支付处理
      }
      this.loading = true;
    },
    setWxConfig(option) {
      const that = this;
      if (option.apiUrl) {
        this.payAction = option.apiUrl;
        this.payParams = option.params.map(item => {
          item.value.replace('"', "&quot;");
          return item;
        });
        this.$nextTick(() => {
          this.$refs.form.submit();
        });
      } else {
        wx.config({
          debug: false, //这里一般在测试阶段先用ture，等打包给后台的时候就改回false,
          appId: option.appId,
          timestamp: option.timeStamp,
          nonceStr: option.nonceStr,
          signature: option.paySign,
          jsApiList: ["chooseWXPay"]
        });
        wx.ready(function() {
          wx.checkJsApi({
            jsApiList: ["chooseWXPay"],
            success: function() {
              console.log("seccess");
            },
            fail: function(res) {
              console.log("fail");
              console.log(res);
            }
          });
          that.jsApiCall(option);
        });
      }
    },
    jsApiCall(option) {
      const _this = this;
      wx.ready(function() {
        wx.chooseWXPay({
          appId: option.appId,
          timestamp: option.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: option.nonceStr, // 支付签名随机串，不长于 32
          package: option.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: "MD5", // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: option.paySign, // 支付签名
          success: function() {
            //跳转到支付成功页面有这个页面
            // console.log("支付成功", res);
            _this.onSubmitPayAfter();
          },
          cancel: function() {
            //取消支付
            _this.$router.push({
              name: "servePreOrderResult",
              query: { Id: _this.Id }
            });
          },
          fail: function() {
            alert("支付失败，请重试");
          }
        });
      });
    },
    onSelect(item) {
      this.show = false;
      delete item.id;
      const params = {
        payMethod: item.value,
        id: this.Id,
        payType: 1
      };
      this.onWeChatPayBefore(params)
        .then(() => {
          this.$post("Pay_Wechat", params)
            .then(res => {
              this.loading = false;
              this.setWxConfig(res.data);
            })
            .catch(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          this.loading = false;
        });

      // this.$post("Booking_Pay", { CardBookingId: this.Id }).then(res => {
      //   //处理完成后跳转
      //   this.$router.push({
      //     name: "servePreOrderResult",
      //     query: { Id: this.Id }
      //   });
      // });
    },
    onSubmitPayAfter() {
      this.$router.push({
        name: "servePreOrderResult",
        query: { Id: this.Id }
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
